

import React, { memo } from 'react';
import { Dropdown } from '../../../../../ui-kit';
import getConstants from '../../../constants';

const { ASPECT_RATIOS } = getConstants();









function AspectRatio({
  aspectRatio,
  onChangeAddon,
  label = 'Aspect Ratio',
  disabled,
  hideLabel
}) {
  return (
    <Dropdown
      onChange={onChangeAddon('aspectRatio')}
      options={ASPECT_RATIOS}
      defaultValue={ASPECT_RATIOS.find((ratio) => ratio.value === aspectRatio)}
      label={hideLabel ? '' : label}
      fontSize={12}
      hideSeparators
      showSelectedSuffix
      disabled={disabled}
      type="BUTTON" />);


}

export default memo(AspectRatio);